import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function KvkkAydinlatmaMetni() {
  return (
    <PolicyPage
      slug="kvkk-aydinlatma-metni"
      title="KVKK Aydınlatma Metni"
      intro="6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında Abonelik İptal olarak kişisel verilerinizi nasıl işlediğimize dair sizi bilgilendirmek isteriz. Bu metin genel bilgilendirme amaçlıdır; hukuki tavsiye niteliği taşımaz."
      metaTitle="KVKK Aydınlatma Metni | Abonelik İptal"
      metaDescription="Abonelik İptal'in KVKK kapsamında kişisel verilerinizi hangi amaçla, hangi hukuki sebeple işlediğine dair aydınlatma metni."
      sections={[
        {
          heading: "Veri sorumlusu",
          body: [
            'Bu metin kapsamında veri sorumlusu marka adıyla "Abonelik İptal"tir. İletişim: destek@abonelikiptal.com. Abonelik İptal resmi bir kurum değildir; hukuki danışmanlık vermez.',
          ],
        },
        {
          heading: "İşlenen kişisel veriler",
          bullets: [
            "Kullanıcının sunduğu sorun tipi, kurum ve problem detayı",
            "Kendi yazdığı serbest metin açıklaması",
            "Yüklediği dosyalara ait dosya adı, boyutu ve türü (metadata)",
            "Site kullanımına ilişkin standart teknik günlük verileri",
          ],
        },
        {
          heading: "İşleme amaçları",
          bullets: [
            "Hazır başvuru metni, belge listesi ve takip planı oluşturmak",
            "Sürecinizi kişiselleştirmek ve doğru yönlendirme sağlamak",
            "Servis kalitesini, performansı ve güvenliği sağlamak",
            "Yasal yükümlülükleri yerine getirmek",
          ],
        },
        {
          heading: "Hukuki sebepler",
          bullets: [
            "Kanunlarda açıkça öngörülmesi (KVKK m.5/2-a)",
            "Sözleşmenin kurulması veya ifası için gerekli olması (KVKK m.5/2-c)",
            "Meşru menfaatler için veri işlenmesinin zorunlu olması (KVKK m.5/2-f)",
            "İlgili kişinin açık rızası (yalnızca gerektiğinde)",
          ],
        },
        {
          heading: "Aktarım",
          body: [
            "Kişisel verileriniz; barındırma, e-posta ve teknik altyapı hizmeti alınan tedarikçilere hizmetin sağlanması için sınırlı ölçüde aktarılabilir. Bu tedarikçiler veri işleyen sıfatıyla ve gizlilik yükümlülükleri altında hareket eder. Reklam ve pazarlama amaçlı üçüncü taraflarla paylaşım yapılmaz.",
          ],
        },
        {
          heading: "Saklama süresi",
          body: [
            "Kişisel verileriniz, işleme amacının gerektirdiği süre boyunca ve yasal saklama süresi kadar tutulur. MVP sürümünde yüklediğiniz belgelerin içeriği kalıcı dosya olarak saklanmaz.",
          ],
        },
        {
          heading: "İlgili kişi hakları",
          bullets: [
            "İşlenen kişisel verileriniz hakkında bilgi talep etme",
            "Verilerin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme",
            "Verilerin düzeltilmesini, silinmesini veya yok edilmesini isteme",
            "İşlenmeye itiraz etme ve zararınızı giderilmesini talep etme (KVKK m.11)",
          ],
        },
        {
          heading: "İletişim",
          body: [
            "KVKK kapsamındaki haklarınızı kullanmak için destek@abonelikiptal.com adresine e-posta göndererek başvurabilirsiniz. Başvurunuzu değerlendirip yasal süreler içinde yanıtlarız.",
          ],
        },
      ]}
    />
  );
}
